import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Store } from '@ngxs/store';
import {
  ConnectionsSelectors,
  CreateBotConnection,
  RemoveBotConnection,
  UpdateBotConnection,
} from 'projects/brn-frontend/src/app/core/store/bot-connections';
import { BotSelectors } from 'projects/brn-frontend/src/app/core/store/bot/bot.selectors';
import { PortalService } from './../../../../core/services/portal.service';

@Component({
  selector: 'brn-slack-connection-modal',
  templateUrl: './slack-connection-modal.component.html',
  styleUrls: ['./slack-connection-modal.component.scss']
})
export class SlackConnectionModalComponent implements OnInit {

  @ViewSelectSnapshot(ConnectionsSelectors.pendingStatus)
  pendingStatus!: boolean;

  @ViewSelectSnapshot(BotSelectors.botId)
  botId!: string;

  newConnection = true;

  slackForm = this.formBuilder.group({
    user: ['', Validators.required],
    user_secret: ['', Validators.required],
    redirect_uri: ['', Validators.required]
  });

  constructor(
    private store: Store,
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<SlackConnectionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data.providerData) {
      const providerData = data.providerData;
      this.newConnection = false;
      const botId = this.botId || this.data.botId || 'undefined';
      providerData.redirect_uri = PortalService.ApiUrl + '/message/receive/slack?bot_id=' + botId;
      this.slackForm.patchValue(providerData);
    }
  }

  ngOnInit(): void { }

  get validForm(): boolean {
    return this.slackForm.valid;
  }

  createConnection(): void {
    if (!this.validForm || this.pendingStatus) {
      return;
    }
    const providerData = this.slackForm.value;
    this.store.dispatch(new CreateBotConnection('slack', providerData));
  }

  updateConnection(): void {
    if (!this.validForm || this.pendingStatus) {
      return;
    }
    const providerData = this.slackForm.value;
    this.store.dispatch(new UpdateBotConnection('slack', providerData));
  }

  removeConnection(): void {
    if (this.pendingStatus) {
      return;
    }
    this.store.dispatch(new RemoveBotConnection('slack'));
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
